import axios from 'axios';

import i18n from '@/i18n';
import { getCurrentLanguage } from '@/utilities/language';

let interceptorId: number | undefined;

export function setupAxiosLanguageInterceptor() {
  if (interceptorId !== undefined) {
    return;
  }

  interceptorId = axios.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = getCurrentLanguage(i18n);
    return config;
  });
}
